import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Material Imports
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { Conversation } from '../../services/conversation';
import { environment } from '../../../environments/environment';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatChip } from '@angular/material/chips';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PermissionsDialogComponent } from './permissions-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../services/auth';
import { PermissionDeniedDialogComponent } from '../permission-denied-dialog.component';


export interface User {
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  status: boolean;
  permissions: {
    viewConversations: boolean;
    sendMessages: boolean;
    manageUsers: boolean;
    viewInsights:boolean
  };
}

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    // Material Modules (not components!)
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSpinner,
    MatChip,
    MatTooltipModule
  ],
  templateUrl: './settings.html',
  styleUrl: './settings.scss'
})
export class Settings {



displayedColumns: string[] = ['name', 'email', 'phone', 'status', 'actions'];  isLoading: boolean;
user;
admin;

    constructor(
    private route: ActivatedRoute,
    private conversationService: Conversation,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private auth: AuthService
   
  ) {
    this.getUsers();
    this.auth.user$.subscribe(async res=>{
      if(res){
        this.user = res;
         const tokenResult = await this.user.getIdTokenResult();
        const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
        this.admin = tokenResult.claims.admin === true;
         
        // console.log(res)
      }
    })

    
  }

 users = new MatTableDataSource<User>([]);

  newUser = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    permissions: {
      viewConversations: false,
      sendMessages: false,
      manageUsers: false,
      viewInsights:false
    },
  };

  async addUser() {
    if(!this.admin){
       const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
        width: '400px',
        disableClose: true, // Prevent escape/click-out
        autoFocus: true
      });

      // Wait for user to click OK
      await dialogRef.afterClosed().toPromise();
  } else {
    if (this.newUser.firstName && this.newUser.email) {
      console.log(this.newUser)
      // this.users.data.push({ ...this.newUser });
      const newUser = this.newUser
     

      this.conversationService.postMessage(newUser, environment.endpoints.CREATE_USER) // Adjust 'messages' if needed
      .then(() => {
        console.log('Message sent successfully!');
        // this.global.showAlert('Message sent successfully',"Success");
        // Success: Clear input and re-enable button
        this.isLoading = false; 
         this.resetNewUser();
        ;
      })
      .catch(error => {
        console.error('Error sending message:', error);
        this.isLoading = false; // Re-enable button even on error
        // this.global.showAlert(error.error.msg,error.error.title);
  
        // Handle the error, e.g., display an error message to the user
      });
    }
  }
    
  }

  getUsers(){
    this.conversationService.getUsers().subscribe(users=>{
      if(users){
        this.users.data = users
      }
    })
  }

  formatPhone(phone: string): string {
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length === 10
      ? `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`
      : phone;
  }

  resetNewUser() {
    this.newUser = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      permissions: {
        viewConversations: false,
        sendMessages: false,
        manageUsers: false,
        viewInsights:false
      },
    };
  }

  viewUser(user: any) {
    console.log('Viewing user', user);
  }

  // Toggle Activate / Deactivate
  async toggleUserStatus(user: User) {
         if(!this.admin){
       const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
        width: '400px',
        disableClose: true, // Prevent escape/click-out
        autoFocus: true
      });

      // Wait for user to click OK
      await dialogRef.afterClosed().toPromise();
  } else {
    const action = user.status ? 'disable' : 'enable';
    const endpoint = `${environment.endpoints.CREATE_USER}/${user.uid}/${action}`;

    this.conversationService.postMessage({user:user}, endpoint) // Adjust 'messages' if needed
    .then(() => {
      console.log('Message sent successfully!');
      user.status = !user.status;
      this.snackBar.open(`User ${user.status ? 'activated' : 'deactivated'}`, 'Close', { duration: 2000 });
      // this.global.showAlert('Message sent successfully',"Success");
      // Success: Clear input and re-enable button
      this.isLoading = false; 
      
      ;
    })
    .catch(error => {
      console.error('Error sending message:', error);
      this.isLoading = false; // Re-enable button even on error
      // this.global.showAlert(error.error.msg,error.error.title);
       this.snackBar.open(`Failed to ${action} user`, 'Close', { duration: 4000 });

      // Handle the error, e.g., display an error message to the user
    });
  }
    
   

   
  }

  // Open Permissions Modal
  openPermissionsDialog(user: User) {
    const dialogRef = this.dialog.open(PermissionsDialogComponent, {
      width: '400px',
      data: { ...user }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updatePermissions(user.uid, result.permissions);
      }
    });
  }

  // Update Permissions via API
  async updatePermissions(uid: string, permissions: any) {

      if(!this.admin){
       const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
        width: '400px',
        disableClose: true, // Prevent escape/click-out
        autoFocus: true
      });

      // Wait for user to click OK
      await dialogRef.afterClosed().toPromise();
  } else {
     this.conversationService.postMessage({ permissions }, `${environment.endpoints.CREATE_USER}/${uid}/permissions`) // Adjust 'messages' if needed
    .then(() => {
      console.log('Message sent successfully!');
      const user = this.users.data.find(u => u.uid === uid);
      if (user) user.permissions = permissions;
      this.snackBar.open('Permissions updated', 'Close', { duration: 2000 });
      // this.global.showAlert('Message sent successfully',"Success");
      // Success: Clear input and re-enable button
      this.isLoading = false; 
      
      ;
    })
    .catch(error => {
      console.error('Error sending message:', error);
      this.isLoading = false; // Re-enable button even on error
    });

  }
  
   
  }

 

  removeUser(user: User) {
    if (!confirm(`Delete ${user.firstName} ${user.lastName}?`)) return;

    

    
  }
}